<div class="main px-3 py-3">
  <div class="bg-grey">
  </div>
  <div class="page-header">
    <div class="title-container">チェーン更新</div>
  </div>
  <mat-tab-group class="mat-tab-fill-height" animationDuration="0ms">
    <mat-tab label="参照/ダウンロード" class="label">
      <!-- 参照/ダウンロード -->
      <div class="looker-field">
        <div id="l-update-calendar" class="looker-embed"></div>
        <div class="download-button mt-3">
          <app-download-button></app-download-button>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="アップロード" class="label">
      <!-- アップロード -->
      <div class="upload-field">
        <div class="message-title">メッセージ</div>
        <div class="upload-control-filed">
          <app-message-field #messageField class="message-field"></app-message-field>
          <app-upload-file class="file-drop-field" (fileEvent)="setUpdatingChainFile($event)"
            [acceptExtension]="allowedExtension"></app-upload-file>
        </div>
        <div class="upload-button">
          <button mat-raised-button (click)="uploadUpdatingChainFile()">
            <i class="fa fa-upload"> アップロード</i>
          </button>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
